import { dispatch } from '../store';
import { ApiClients } from '../../utils/axios';
import { getBannerList, startLoading, hasError, getBanner } from '../slices/banner';
import {
  BannerList,
  BannerListParams,
  ParamsBannerForForm,
  ParamMassBannerSort,
  Banner,
} from 'types/banner';

const { axiosApp } = ApiClients;

export function getBannerListThunk(params: BannerListParams) {
  return async () => {
    dispatch(startLoading());
    try {
      const response: { data: BannerList } = await axiosApp.get('banners', { params });

      dispatch(getBannerList(response.data));

      return response.data;
    } catch (error) {
      dispatch(hasError(error));
    }
  };
}

export function getBannerThunk(id: number) {
  return async () => {
    dispatch(startLoading());

    try {
      const response: { data: { data: Banner } } = await axiosApp.get(`banners/${id}`);

      dispatch(getBanner(response.data.data));

      return response.data.data;
    } catch (error) {
      dispatch(hasError(error));
    }

    return null;
  };
}

export function editBannerThunk(id: number, params: ParamsBannerForForm) {
  return async () => {
    dispatch(startLoading());
    try {
      const response: { data: { data: Banner } } = await axiosApp.put(`banners/${id}`, {
        ...params,
      });

      dispatch(getBanner(response.data));

      return response.data.data;
    } catch (error) {
      dispatch(hasError(error));
    }

    return null;
  };
}

export function setMassSortBannerThunk(params: ParamMassBannerSort[]) {
  return async () => {
    dispatch(startLoading());
    try {
      await axiosApp.post('banners/sort', {
        banners: params,
      });

      return true;
    } catch (error) {
      dispatch(hasError(error));
    }
  };
}

export function createBannerThunk(params: ParamsBannerForForm) {
  return async () => {
    dispatch(startLoading());
    try {
      const res: { data: { data: Banner } } = await axiosApp.post(`banners`, {
        ...params,
      });

      return res.data.data;
    } catch (error) {
      dispatch(hasError(error));
    }

    return null;
  };
}

export function deleteBannerThunk(id: number) {
  return async () => {
    dispatch(startLoading());
    try {
      await axiosApp.delete(`banners/${id}`);

      dispatch(getBannerListThunk({}));
    } catch (error) {
      dispatch(hasError(error));
    }
  };
}
